<template>
  <div class="whatsapp-configuracoes">
    <v-container class="pa-0" fluid>
      <v-row>
        <v-col class="py-0">
          <multiple-numbers-external-provider />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    MultipleNumbersExternalProvider: () => import('@/modules/campanhas/whatsapp/views/components/MultipleNumbersExternalProvider.vue'),
  },
}
</script>
